export default function PublishIcon({ className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      className={className}
    >
      <path
        d="M6.66667 15.7742C5.70074 15.5988 4.80919 15.2744 3.992 14.8009C3.176 14.3268 2.47141 13.7422 1.87822 13.0471C1.28504 12.352 0.823704 11.5641 0.494222 10.6836C0.164741 9.80415 0 8.872 0 7.88711C0 6.60711 0.276148 5.41689 0.828444 4.31644C1.38074 3.216 2.20889 2.25215 3.31289 1.42489H0.666667V0.536H4.88889V4.75822H4V2.02933C2.95704 2.74933 2.17778 3.61837 1.66222 4.63644C1.14667 5.65452 0.888889 6.73807 0.888889 7.88711C0.888889 9.5843 1.41956 11.0844 2.48089 12.3876C3.54281 13.6907 4.93807 14.5159 6.66667 14.8631V15.7742ZM6.73333 11.3609L3.59289 8.21511L4.22222 7.58667L6.73333 10.0969L11.7778 5.05244L12.4071 5.68711L6.73333 11.3609ZM11.1111 15.2542V11.032H12V13.7618C13.0311 13.027 13.8074 12.1514 14.3289 11.1351C14.8504 10.1188 15.1111 9.03615 15.1111 7.88711C15.1111 6.19052 14.5804 4.69067 13.5191 3.38756C12.4572 2.08385 11.0619 1.25837 9.33333 0.911111V0C11.277 0.347852 12.8741 1.25333 14.1244 2.71644C15.3748 4.17956 16 5.90311 16 7.88711C16 9.16711 15.7239 10.3603 15.1716 11.4667C14.6193 12.573 13.7911 13.5396 12.6871 14.3662H15.3333V15.2551L11.1111 15.2542Z"
        fill="currentColor"
      />
    </svg>
  );
}

